import React from 'react';
import { CheckIcon, CreditCardIcon, LockIcon, MailIcon } from 'lucide-react';
import { GoldPlaque } from '../ui/GoldPlaque';
import { CtaButton } from '../ui/CtaButton';
import { BOX_MOCKUP, BOX_MOCKUP_ALT, DELIVERY_NOTE, PRICE_CURRENCY_NOTE, offerCoreInclusions, optionalExtras } from '../../data/site';
const assurance = [{
  icon: LockIcon,
  label: 'Secure checkout'
}, {
  icon: MailIcon,
  label: 'Download links by email'
}, {
  icon: CreditCardIcon,
  label: 'Payment options shown at checkout'
}];
export function Offer() {
  return <section id="offer-details" aria-labelledby="offer-title" className="bg-mint py-14 text-ink sm:py-20 lg:py-24" data-id="element-195" data-mp="3f2p8anl72yqc">
      <div className="mx-auto max-w-page px-5 text-center lg:px-8" data-id="element-196" data-mp="3jxmdtkj9mpyh">
        <GoldPlaque tone="light" data-id="element-197" data-mp="3nwc062ma7hu9">The complete pack</GoldPlaque>
        <h2 id="offer-title" className="mx-auto mt-5 max-w-4xl font-display text-[40px] font-bold uppercase leading-[0.92] text-ink sm:mt-6 sm:text-[64px] lg:text-[80px]" data-id="element-198" data-mp="3swgfhpbge6iw">
          Your badminton unit, <span className="text-gold-dark" data-id="element-199" data-mp="1km9k8ynmlxrg">ready to teach</span>
        </h2>

        <div className="mx-auto mt-8 max-w-[576px] rounded-2xl border border-[#DCE5D2] sm:mt-12 bg-white text-left shadow-[0_30px_60px_-30px_rgba(9,40,29,0.35)]" data-id="element-200" data-mp="1flvjm1octq3g">
          <div className="px-5 pb-7 pt-7 sm:px-10 sm:pb-8 sm:pt-10" data-id="element-201" data-mp="1bmmtd6siwacn">
            <p className="text-center text-[13px] font-bold uppercase tracking-[0.16em] text-gold-ink" data-id="element-202" data-mp="16n9x5vfrhqxe">
              Core guide + 5 bonuses
            </p>
            <h3 className="mt-2 text-center font-display text-[28px] font-bold uppercase leading-none text-ink sm:text-[36px]" data-id="element-203" data-mp="1z9umyrgl9uyu">
              Badminton Class Ready — Complete Pack
            </h3>

            <img src={BOX_MOCKUP} alt={BOX_MOCKUP_ALT} width={1374} height={1145} loading="lazy" className="mx-auto mt-6 block h-auto w-full max-w-[340px] drop-shadow-[0_18px_24px_rgba(8,39,33,0.25)] sm:mt-8" data-id="element-204" data-mp="1pl2zowmh3yu9" />
            <p className="mt-5 text-center text-sm text-[#4B5563]" data-id="element-205" data-mp="314z3ywvqshgb">Digital PDF files — nothing is shipped.</p>

            <hr className="my-8 border-[#E5ECE7]" data-id="element-206" data-mp="363inkqmv5h5i" />

            <p className="text-center text-[13px] font-bold uppercase tracking-[0.16em] text-forest" data-id="element-207" data-mp="366el4dusu3tf">What’s included</p>
            <ul className="mt-5 grid gap-x-6 gap-y-3.5 sm:grid-cols-2" data-id="element-208" data-mp="2weio764g8jqs">
              {offerCoreInclusions.map(item => <li key={item} className="flex gap-2.5 text-[15.5px] font-medium leading-snug text-[#1F2937]" data-id="element-209" data-mp="2idy3g4ez4dun">
                  <span aria-hidden="true" className="mt-px flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cream text-gold-dark" data-id="element-210" data-mp="2nevjobgfaxti">
                    <CheckIcon className="h-3 w-3" strokeWidth={3.5} data-id="element-211" data-mp="2dfwnhscugune" />
                  </span>
                  {item}
                </li>)}
              <li className="flex gap-2.5 text-[15.5px] font-bold leading-snug text-forest sm:col-span-2" data-id="element-212" data-mp="7ng16cd6kio0">
                <span aria-hidden="true" className="mt-px flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cream text-gold-dark" data-id="element-213" data-mp="bnqjmoi5t1jr">
                  <CheckIcon className="h-3 w-3" strokeWidth={3.5} data-id="element-214" data-mp="1s5ij5abx0ruc" />
                </span>
                + 5 bonus resources included
              </li>
            </ul>
            <p className="mt-6 text-center text-[13.5px] leading-relaxed text-[#4B5563]" data-id="element-215" data-mp="25y87vmitwav5">
              Optional, separately priced at checkout: {optionalExtras.join(' · ')}. This pack is complete without them.
            </p>

            <hr className="my-8 border-[#E5ECE7]" data-id="element-216" data-mp="2avzwo7o6fgv4" />

            <div className="text-center" data-id="element-217" data-mp="2av71m3ykyfst">
              <p className="inline-flex items-start font-display font-bold leading-none text-forest" data-id="element-218" data-mp="2ovriuvouk3k7">
                <span className="mt-auto pb-3 text-[40px] sm:text-[46px]" data-id="element-219" data-mp="2jvn1z4k116tg">$</span>
                <span className="text-[104px] tracking-[-0.02em] sm:text-[120px]" data-id="element-220" data-mp="uh8hwxjye84a">27</span>
                <span className="mt-auto pb-3 pl-2 font-sans text-[15px] font-medium text-[#4B5563]" data-id="element-221" data-mp="uj1lu536me8l">USD</span>
              </p>
              <ul className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-[12.5px] font-bold uppercase tracking-[0.14em] text-[#374151]" data-id="element-222" data-mp="rxbuznyepeha">
                <li data-id="element-223" data-mp="w08f5j3lhinc">One-time payment</li>
                <li aria-hidden="true" className="h-1 w-1 rounded-full bg-gold-dark" data-id="element-224" data-mp="10x7a23v31tml" />
                <li data-id="element-225" data-mp="15x3e233s5l25">No subscription</li>
              </ul>
            </div>

            <CtaButton target="checkout" size="xl" className="mt-8 w-full" data-id="element-226" data-mp="15u7c83otac8f">
              Get the pack now
            </CtaButton>

            <p className="mt-4 flex items-center justify-center gap-2 text-center text-[13.5px] font-medium text-[#374151]" data-id="element-227" data-mp="d74jxtaqaxqm">
              <MailIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-gold-dark" data-id="element-228" data-mp="i67g0o8qdtmg" />
              {DELIVERY_NOTE}
            </p>

            <hr className="my-6 border-[#E5ECE7]" data-id="element-229" data-mp="mzip6w10mmhj" />

            <ul className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2.5 text-[13px] font-medium text-[#374151]" data-id="element-230" data-mp="3lmo5s792ldvn">
              {assurance.map(({
              icon: Icon,
              label
            }) => <li key={label} className="flex items-center gap-1.5" data-id="element-231" data-mp="3j28dshiz1qc1">
                  <Icon aria-hidden="true" className="h-4 w-4 text-[#4B5563]" data-id="element-232" data-mp="3e4gaysgsgjt2" />
                  {label}
                </li>)}
            </ul>
            <p className="mt-5 text-center text-[13px] leading-relaxed text-[#4B5563]" data-id="element-233" data-mp="393936tenbkme">
              Digital teaching resources. Rackets, shuttlecocks and other equipment are not included.
            </p>
          </div>
        </div>
        <p className="mx-auto mt-6 max-w-xl text-[13.5px] text-[#4B5563]" data-id="element-234" data-mp="2vdp6o5bnrjlj">{PRICE_CURRENCY_NOTE}</p>
      </div>
    </section>;
}